import { useState } from 'react'
import { scanService } from '../services/scanService'
import type { ScanFormData } from '../validation/schemas'

export function useScanSubmit() {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submitScan = async (data: ScanFormData): Promise<boolean> => {
    setIsSubmitting(true)
    setError(null)

    console.debug('Submitting scan with data:', data)

    try {
      // If using separate date/time fields, combine them into Date objects
      let finalTimeFrame = data.timeFrame
      if (
        data.timeFrame.preset === 'custom' &&
        data.timeFrame.fromDate &&
        data.timeFrame.fromTime &&
        data.timeFrame.toDate &&
        data.timeFrame.toTime
      ) {
        // Convert dd/MM/yyyy format to yyyy-MM-dd format for Date constructor
        const fromDateParts = data.timeFrame.fromDate.split('/')
        const toDateParts = data.timeFrame.toDate.split('/')

        const fromDateISO = `${fromDateParts[2]}-${fromDateParts[1].padStart(2, '0')}-${fromDateParts[0].padStart(2, '0')}`
        const toDateISO = `${toDateParts[2]}-${toDateParts[1].padStart(2, '0')}-${toDateParts[0].padStart(2, '0')}`

        finalTimeFrame = {
          preset: data.timeFrame.preset,
          from: new Date(`${fromDateISO}T${data.timeFrame.fromTime}`),
          to: new Date(`${toDateISO}T${data.timeFrame.toTime}`),
        }
      }

      // Ensure keywords is always an array (even if empty)
      const payload = {
        ...data,
        timeFrame: finalTimeFrame,
        keywords: data.keywords || [],
      }

      // Call the service to create the scan
      await scanService.createScan(payload)

      return true // Success
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to create scan'
      setError(errorMessage)
      console.error('Error creating scan:', err)
      return false // Failure
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    submitScan,
    isSubmitting,
    error,
  }
}
